export function clampMark(value, max) {
  if (value === "" || value == null) return "";
  const mark = Number(value);
  return Number.isFinite(mark) ? String(Math.min(max, Math.max(0, mark))) : "";
}

export function clampScores(scores, fields) {
  let nextScores = scores;
  for (const [key, , max] of fields) {
    const value = scores[key];
    if (value === "" || value == null) continue;
    const boundedValue = clampMark(value, max);
    if (boundedValue === String(value)) continue;
    if (nextScores === scores) nextScores = { ...scores };
    nextScores[key] = boundedValue;
  }
  return nextScores;
}
